import { FC, useCallback } from 'react'
import { useIntl } from 'react-intl'

import { App, Button, Form, Input } from 'antd'

import { useCreateContactMutation } from '../../graphql'

type FormValues = {
  email: string
  message: string
}

const Contact: FC = () => {
  const { formatMessage } = useIntl()
  const [form] = Form.useForm()
  const { notification } = App.useApp()
  const [createContact] = useCreateContactMutation()
  const onFinish = useCallback(
    async (data: FormValues) => {
      await createContact({ variables: { data } })
        .then(({ data, errors }) => {
          if (errors || !data?.createContact) {
            notification.error({ message: formatMessage({ id: 'contact.error.title' }) })
          } else {
            notification.success({ message: formatMessage({ id: 'contact.success.title' }) })
          }
        })
        .catch(() => notification.error({ message: formatMessage({ id: 'contact.error.title' }) }))
    },
    [createContact, notification, formatMessage],
  )

  return (
    <Form<FormValues> layout={'vertical'} form={form} onFinish={onFinish}>
      <Form.Item
        name={'email'}
        label={formatMessage({ id: 'contact.form.email' })}
        rules={[{ required: true, message: formatMessage({ id: 'form.required-field-error' }) }]}
      >
        <Input type={'email'} />
      </Form.Item>
      <Form.Item
        name={'message'}
        label={formatMessage({ id: 'contact.form.message' })}
        rules={[{ required: true, message: formatMessage({ id: 'form.required-field-error' }) }]}
      >
        <Input.TextArea rows={10} />
      </Form.Item>
      <Form.Item style={{ paddingTop: 16 }}>
        <Button block htmlType={'submit'} type={'primary'}>
          {formatMessage({ id: 'contact.form.button' })}
        </Button>
      </Form.Item>
    </Form>
  )
}

export { Contact as default }
